module.exports = __webpack_public_path__ + "img/success-check.e4153235.svg";